import { Grid } from '@mui/material'
import React, { useEffect, useState } from 'react'
import Title from '../ReusableComponents/title'
import '../../assets/css/SupportCenter.scss'
import FAQTab from '../ReusableComponents/FAQTab'
import axios from 'axios'
import { axiosInstance } from '../../Axios'



const General = () => {

    const [Data, setData] = useState([])

    useEffect(() => {
        axiosInstance
            .get("v2/support/faqs/")
            .then((res) => {
                // if (res.data.category === "General") {
                //     setData(res.data)
                // }
                setData(res.data)
                console.log("____hello_____", res.data);

            })
    }, []);

    return (
        <div>

            {
                Data.map(data => {
                    const category = data.category
                    if (category === "General") {
                        return (
                            <FAQTab
                                Head={data.question}
                                Desc={data.answer}
                            />
                        )
                    } else {
                        <div></div>
                    }
                })
            }

        </div>
    )
}

const AlphaCapitalAccount = () => {
    const [Data, setData] = useState([])

    useEffect(() => {
        axiosInstance
            .get("v2/support/faqs/")
            .then((res) => {
                // if (res.data.category === "General") {
                //     setData(res.data)
                // }
                setData(res.data)
                console.log("____hello_____", res.data);

            })
    }, []);

    return (
        <div>
            {/* {
                Object.keys(Data).map(data => {
                    return (
                        <FAQTab
                            Head={data.question}
                            Desc={data.answer}
                        />
                    )
                })
            } */}

            {
                Data.map(data => {
                    const category = data.category
                    if (category === "Alpha Capital") {
                        return (
                            <FAQTab
                                Head={data.question}
                                Desc={data.answer}
                            />
                        )
                    } else {
                        <div></div>
                    }
                })
            }

        </div>
    )
}

const FAQ = () => {

    const [radio, setRadio] = useState("General")
    const [Show, setShow] = useState(false)

    const handleShow = () => {
        setShow(!Show)
    }

    const handleChange = (e) => {
        let Option = e.currentTarget.getAttribute("value")
        setRadio(Option)
        console.log(Option);
        setShow(false)
    }

    return (
        <Grid md={12} xs={12} container justifyContent="space-around">
            <Grid className='DeskRadioFaq' md={2} xs={12}>
                <Grid onClick={handleChange} className="gapp-10 d-flex mbb-10" value="General">
                    <div className={"d-flex RadioStat " + (radio === "General" && " RBSelected")}>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="12" cy="12" r="9" fill="white" stroke="#8B8E93" strokeWidth="6" />
                        </svg>
                    </div>
                    <div><Title four>General</Title></div>
                </Grid>
                <Grid onClick={handleChange} className="gapp-10 d-flex mbb-10" value="AlphaCapitalAccount">
                    <div className={"d-flex RadioStat " + (radio === "AlphaCapitalAccount" && " RBSelected")}>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="12" cy="12" r="9" fill="white" stroke="#8B8E93" strokeWidth="6" />
                        </svg>
                    </div>
                    <div><Title four>Alpha Capital Account</Title></div>
                </Grid>

            </Grid>

            <div className='MobileRadioFaq'>
                <div className='MobileRadioFaqCurrent' onClick={handleShow}>{radio}
                    <span className={Show && "Expand"}>
                        <svg width="10" height="20" viewBox="0 0 10 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fillRule="evenodd" clipRule="evenodd" d="M9.53033 0.96967C9.82322 1.26256 9.82322 1.73744 9.53033 2.03033L5.53033 6.03033C5.23744 6.32322 4.76256 6.32322 4.46967 6.03033L0.46967 2.03033C0.176777 1.73744 0.176777 1.26256 0.46967 0.96967C0.762563 0.676777 1.23744 0.676777 1.53033 0.96967L5 4.43934L8.46967 0.96967C8.76256 0.676777 9.23744 0.676777 9.53033 0.96967Z" fill="white" />
                        </svg>
                    </span>
                </div>
                {Show && <div className='MobileRadioFaqDrop'>
                    <Grid onClick={handleChange} className="gapp-10 d-flex mbb-10" value="General">
                        <div><Title four>General</Title></div>
                    </Grid>
                    <Grid onClick={handleChange} className="gapp-10 d-flex mbb-10" value="AlphaCapitalAccount">
                        <div><Title four>Alpha Capital Account</Title></div>
                    </Grid>
                </div>}
            </div>

            <Grid className='FaqMain' md={7} xs={12}>{radio === "General" ? <General /> : <AlphaCapitalAccount />}</Grid>
        </Grid>
    )
}

export default FAQ;